import * as gtm from './src/gtm';
import * as matomo from './src/matomo';
import $ from "jquery";
import {getPrefixedDataSet} from "@elements/data-set-utils";

export const initGtmEventTracking = createEventTracking(gtm);
export const initMatomoEventTracking = createEventTracking(matomo);

function createEventTracking({
     setup,
     trackEvent
 }) {
    return ({
                dataAttributePrefix = 'event-tracking',
                debug = false
            } = {}) => {
        setup({debug});

        // todo repalce with onFind
        $(document.body).on('click', `[data-${dataAttributePrefix}-category]`, function () {
            let clickedElement = this;
            let $clickedElement = $(clickedElement);
            let data = {};

            if (clickedElement.tagName === 'A') {
                data.action = clickedElement.getAttribute('href');
                data.label = trim(clickedElement.textContent);
            }

            data = {
                ...data,
                ...getPrefixedDataSet(dataAttributePrefix, $clickedElement)
            };

            trackEvent(data, {debug});
        })
    }
}

function trim(str) {
    return str.replace(/\s\s+/g, ' ').trim();
}

export function responseTracking(request) {
    // Unpack json response body if the promise was created via fetch
    let promise = request.then(response => (response
        && response.json
        && typeof response.json === 'function'
        && response.clone
        && typeof response.clone === 'function')
        ? response.clone().json()
        : response
    );

    promise.then(result => {
        if (result['__trackingScript']) {
            try {
                eval(result['__trackingScript']);
            } catch (e) {
                console.error(e)
            }
        }
    });
}